<template>
  <div class="trade_stat_container__platforms">
    <span v-for="platform in platforms" :key="platform.code"
          :class="{active:value===platform.code}"
          @click="eventClick(platform.code)"
    >
      {{ platform.name }}
    </span>
  </div>
</template>
<script>
const ALL_PLATFORM = { name: '全平台', code: '' }

// 读取 localStorage 里他人页面写入的平台缓存做兜底,返回数组
function readCache() {
  let list = []
  const cache = localStorage.getItem('platforms')
  if (cache && cache.indexOf('{') > -1) {
    try {
      list = JSON.parse(cache)
    } catch (e) {
      list = []
    }
  }
  return Array.isArray(list) ? list : []
}

export default {
  name: 'TradeTabPlatform',
  data() {
    const cache = readCache()
    return {
      // 先显示缓存(无缓存则只有"全平台"),再在 created 里拉接口刷新
      platforms: cache.length ? [ALL_PLATFORM, ...cache] : [ALL_PLATFORM],
      value: ''
    }
  },
  created() {
    this.getPlatforms()
  },
  methods: {
    // 平台列表:不再只依赖他人写入的 localStorage,本组件自己拉接口兜底
    async getPlatforms() {
      try {
        const { list } = await this.$api.getPlatforms()
        const latest = Array.isArray(list) ? list : []
        if (latest.length) {
          this.platforms = [ALL_PLATFORM, ...latest]
          localStorage.setItem('platforms', JSON.stringify(latest))
        }
      } catch (e) {
        // 接口失败时保留缓存结果
      }
    },
    eventClick(code) {
      this.value = code
      const tmp = this.platforms.find(platform => {
        return platform.code === code
      })
      this.$emit('update:value', this.value)
      this.$emit('update:label', tmp ? tmp.name || '未知' : '未知')
    }
  }
}
</script>
<style lang="scss">
.trade_stat_container__platforms {
  color: #8a8e99;

  span {
    cursor: pointer;
    padding: 8px 20px;
  }

  span.active {
    color: #fe346e;
    font-weight: 700;
  }

  span:first-child {
    padding-left: 0 !important;
  }
}
</style>
